interface Props {
  score: number | null | undefined;
}

export function ScorePill({ score }: Props) {
  const value = Math.round(score ?? 0);
  const tone =
    value >= 80
      ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
      : value >= 60
        ? 'bg-amber-50 text-amber-700 border-amber-200'
        : 'bg-slate-50 text-slate-600 border-slate-200';
  return (
    <span
      className={`px-1.5 py-0.5 rounded-md text-[11px] font-semibold font-mono tabular-nums border shrink-0 ${tone}`}
    >
      {value}
    </span>
  );
}
